import { Dispatch, AnyAction } from 'redux';
import { AppServices } from 'ha/services/getAppServices';
import { UserSearch } from 'ha/services/apiV2/types/UserSearch';
import { SearchParams } from '../types';
import {
  CreateStartAction,
  CreateSuccessAction,
  CreateFailAction,
  ActionsTypes,
} from '../constants';

export function createStart(): CreateStartAction {
  return {
    type: ActionsTypes.CREATE_START,
  };
}

export function createSuccess(payload: UserSearch): CreateSuccessAction {
  return {
    type: ActionsTypes.CREATE_SUCCESS,
    payload,
  };
}

export function createFail(payload: Error): CreateFailAction {
  return {
    type: ActionsTypes.CREATE_FAIL,
    payload,
  };
}

const createSavedSearch = (searchParams: SearchParams, userId: number) => (
  dispatch: Dispatch<AnyAction>,
  _: () => void,
  services: AppServices,
) => {
  dispatch(createStart());

  return services.apiV2
    .saveSearch(userId, searchParams)
    .then(response => {
      dispatch(createSuccess(response.data));
    })
    .catch((error: Error) => {
      dispatch(createFail(error));
    });
};

export default createSavedSearch;
